<!-- Hero Start -->
<section class="bg-half bg-light d-table w-100" id="home">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-12 text-center">
        <div class="page-next-level">
          <h4 class="title"> Frequently Asked Questions </h4>

          <div class="page-next">
            <nav aria-label="breadcrumb" class="d-inline-block">
              <ul class="breadcrumb bg-white rounded shadow mb-0">
                <li class="breadcrumb-item"><a routerLink="/index">Landrick</a></li>
                <li class="breadcrumb-item"><a routerLink="/helpcenter-overview">Help Center</a></li>
                <li class="breadcrumb-item active" aria-current="page">FAQs</li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- Hero End -->

<!-- Start Section -->
<section class="section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-5 col-12 d-none d-md-block">
        <div class="rounded shadow p-4 sticky-bar">
          <ul class="list-unstyled mb-0">
            <li><a href="javascript: void(0);" fragment="tech" class="mouse-down h6 text-dark">Buying
                Questions</a></li>
            <li class="mt-4"><a href="javascript: void(0);" fragment="general"
                class="mouse-down h6 text-dark">General
                Questions</a></li>
            <li class="mt-4"><a href="javascript: void(0);" fragment="payment"
                class="mouse-down h6 text-dark">Payments
                Questions</a></li>
            <li class="mt-4"><a href="javascript: void(0);" fragment="support"
                class="mouse-down h6 text-dark">Support
                Questions</a></li>
          </ul>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-8 col-md-7 col-12">
        <div class="section-title" id="tech">
          <h4>Buying Product</h4>
        </div>
        <div class="faq-content mt-4 pt-2">
          <div ngbAccordion #acc="ngbAccordion" activeIds="ngb-panel-0" closeOthers="true">
            <div ngbAccordionItem id="ngb-panel-0" class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingone">
                    <h6 class="title mb-0 text-dark"> How our <span class="text-primary">Landrick</span> work ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingtwo">
                    <h6 class="title mb-0 text-dark"> What is the main process open account ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingthree">
                    <h6 class="title mb-0 text-dark"> How to make unlimited data entry ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingfour">
                    <h6 class="title mb-0 text-dark"> Is <span class="text-primary">Landrick</span> safer to use with my
                      account ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingfour">
                    <h6 class="title mb-0 text-dark"> How can i contact your technical team ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section-title mt-5" id="general">
          <h4>General Questions</h4>
        </div>

        <div class="faq-content mt-4 pt-3">

          <div ngbAccordion #acc="ngbAccordion" activeIds="ngb-panelfaq" closeOthers="true">
            <div ngbAccordionItem id="ngb-panelfaq" class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingone">
                    <h6 class="title mb-0 text-dark"> How our <span class="text-primary">Landrick</span> work ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingtwo">
                    <h6 class="title mb-0 text-dark"> What is the main process open account ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingthree">
                    <h6 class="title mb-0 text-dark"> How to make unlimited data entry ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingfour">
                    <h6 class="title mb-0 text-dark"> Is <span class="text-primary">Landrick</span> safer to use with my
                      account ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingfour">
                    <h6 class="title mb-0 text-dark"> How can i contact your technical team ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section-title mt-5" id="payment">
          <h4>Payments Questions</h4>
        </div>

        <div class="faq-content mt-4 pt-3">
          <div ngbAccordion #acc="ngbAccordion" activeIds="ngb-panelpayment" closeOthers="true">
            <div ngbAccordionItem id="ngb-panelpayment" class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingone">
                    <h6 class="title mb-0 text-dark"> How our <span class="text-primary">Landrick</span> work ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingtwo">
                    <h6 class="title mb-0 text-dark"> What is the main process open account ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingthree">
                    <h6 class="title mb-0 text-dark"> How to make unlimited data entry ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingfour">
                    <h6 class="title mb-0 text-dark"> Is <span class="text-primary">Landrick</span> safer to use with my
                      account ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingfour">
                    <h6 class="title mb-0 text-dark"> How can i contact your technical team ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section-title mt-5" id="support">
          <h4>Support Questions</h4>
        </div>

        <div class="faq-content mt-4 pt-3">
          <div ngbAccordion #acc="ngbAccordion" activeIds="ngb-panelsupport" closeOthers="true">
            <div ngbAccordionItem id="ngb-panelsupport" class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingone">
                    <h6 class="title mb-0 text-dark"> How our <span class="text-primary">Landrick</span> work ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingtwo">
                    <h6 class="title mb-0 text-dark"> What is the main process open account ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingthree">
                    <h6 class="title mb-0 text-dark"> How to make unlimited data entry ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingfour">
                    <h6 class="title mb-0 text-dark"> Is <span class="text-primary">Landrick</span> safer to use with my
                      account ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <div class="border-0 bg-light" id="headingfour">
                    <h6 class="title mb-0 text-dark"> How can i contact your technical team ? </h6>
                  </div>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                      available, but
                      the majority have suffered alteration in some form.</p>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-12">
        <div class="media align-items-center shadow rounded p-4 features">
          <div class="icons m-0 rounded h2 text-primary text-center px-3">
            <i class="uil uil-envelope-check"></i>
          </div>
          <div class="content ml-4">
            <h5 class="mb-1"><a href="javascript:void(0)" class="text-dark">Get in Touch !</a></h5>
            <p class="text-muted mb-0">This is required when, for text is not yet available.</p>
            <div class="mt-2">
              <a href="javascript:void(0)" class="btn btn-sm btn-soft-primary">Submit a Request</a>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-6 col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <div class="media align-items-center shadow rounded p-4 features">
          <div class="icons m-0 rounded h2 text-primary text-center px-3">
            <i class="uil uil-webcam"></i>
          </div>
          <div class="content ml-4">
            <h5 class="mb-1"><a href="javascript:void(0)" class="text-dark">Start a Meeting</a></h5>
            <p class="text-muted mb-0">This is required when, for text is not yet available.</p>
            <div class="mt-2">
              <a href="javascript:void(0)" class="btn btn-sm btn-soft-primary">Start Video Chat</a>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- End Section -->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-soft-primary back-to-top" id="back-to-top"
  scrollToTop>
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->
